// Sidebar.js
import React from 'react';
import { FaHome, FaCopy, FaPlus, FaList, FaCalendarPlus, FaSignOutAlt, FaChartBar, FaPoll, FaGift } from 'react-icons/fa';
import '../App.css';
import { apiFetch } from '../api';

export default function Sidebar({ mode, setMode }) {
  const menuItems = [
    { key: 'dashboard', label: 'Dashboard', icon: <FaHome /> },
    { key: 'create-new', label: 'Neuen Kurs anlegen', icon: <FaPlus /> },
    { key: 'manage', label: 'Kursverwaltung', icon: <FaList /> },
    { key: 'new-semester-import', label: 'Semester anlegen', icon: <FaCalendarPlus /> },
    { key: 'analytics', label: 'Analytics', icon: <FaChartBar /> },
    { key: 'surveys',             label: 'Umfragen',             icon: <FaPoll /> },
    { key: 'events', label: 'Events', icon: <FaCalendarPlus /> },
    { key: 'xmas-greetings', label: 'Weihnachtsgrüße', icon: <FaGift /> },
  ];

  const handleLogout = async () => {
    try {
      const res = await apiFetch("logout.php", { method: "POST" });
      const json = await res.json();
      alert(json.message || "Erfolgreich abgemeldet");
      window.location.href = "/#/login"; // oder route zurück zur Login-Seite
    } catch (err) {
      alert("Fehler beim Logout");
    }
  };

  return (
    <div className="sidebar">
      {menuItems.map(item => (
        <button
          key={item.key}
          className={`nav-button ${mode === item.key ? 'active' : ''}`}
          onClick={() => setMode(item.key)}
        >
          {item.icon}
          <span>{item.label}</span>
        </button>
      ))}

      

      <button
        className="logout-button"
        onClick={handleLogout}
        style={{ marginTop: 'auto', color: 'crimson' }}
      >
        <FaSignOutAlt />
        <span>Logout</span>
      </button>
    </div>
  );
}
